import { Suspense, useEffect } from 'react';

import { QueryClient, QueryClientProvider, type DefaultOptions } from '@tanstack/react-query';

import { useCrossTabQuerySync } from './useCrossTabQuerySync';

export const defaultQueryOptions: DefaultOptions = {
  queries: {
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  },
};

export const defaultQueryClient = new QueryClient();

type Props = {
  client?: QueryClient;
};

const CrossTabQuerySync: React.FC = () => {
  useCrossTabQuerySync();
  return null;
};

export const ShippoQueryClientProvider: React.FC<Props> = ({
  children,
  client = defaultQueryClient,
}) => {
  useEffect(() => {
    client.setDefaultOptions(defaultQueryOptions);
  }, [client]);
  return (
    <Suspense fallback="">
      <QueryClientProvider client={client}>
        <CrossTabQuerySync />
        {children}
      </QueryClientProvider>
    </Suspense>
  );
};
